import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function PasswordResetRedirector() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const resetToken = (params.get("resetToken") || "").toString();
    if (!resetToken) return;

    // Evitar loop e preservar a experiência do usuário:
    // ao abrir o link do email (/?resetToken=...), redirecionar internamente
    // para a tela de redefinição (sem depender de configuração do servidor).
    navigate(`/reset-password?token=${encodeURIComponent(resetToken)}`, {
      replace: true,
    });
  }, [location.search, navigate]);

  return null;
}

